import { TipoRespuesta } from '../enums/enumTipoRespuesta.model';

export class ResponseBase {
    mensaje: string;
    tipoRespuesta: TipoRespuesta;
    autorizado: boolean;
}
